/**
 * 
 */

import { setCommentsById, setCards, parseAllCards } from 'redux/actions'

import { batchActions } from 'redux-batched-actions'
import { EditorState } from 'draft-js'
import { Orchard, ignoreClientError } from 'shared/orchard'
import { getSelectionText } from 'shared/draftHelpers'


export function fetchCommentThreads (slug) {
  return async (dispatch) => {
    try {
      const {
        commentThreads,
        comments,
        cards,
        mostRecentCommentThreads,
      } = await Orchard.harvest(`cases/${slug}/comment_threads`)
      dispatch(
        batchActions([
          setCommentsById(comments),
          setCommentThreadsById(commentThreads),
          setCards(cards),
          setMostRecentCommentThreads(mostRecentCommentThreads.map(String)),
        ])
      )
      dispatch(parseAllCards())
    } catch (e) {
      ignoreClientError(e) // 401 (session expired) / 404 (case gone)
    }
  }
}

export function setCommentThreadsById (
  commentThreadsById
) {
  return { type: 'SET_COMMENT_THREADS_BY_ID', commentThreadsById }
}

export function setMostRecentCommentThreads (
  mostRecentCommentThreads
) {
  return { type: 'SET_MOST_RECENT_COMMENT_THREADS', mostRecentCommentThreads }
}

export function createCommentThread (
  cardId,
  editorState
) {
  return async (dispatch) => {
    const originalHighlightText = getSelectionText(editorState)

    try {
      const newCommentThread = await Orchard.graft(
        `cards/${cardId}/comment_threads`,
        { commentThread: { originalHighlightText }}
      )
      dispatch(addCommentThread(newCommentThread))
      return newCommentThread.id
    } catch (e) {
      // e.g. 403 when not permitted to comment; the caller floats this off a keypress.
      ignoreClientError(e)
    }
  }
}

export function createUnattachedCommentThread () {
  return async (dispatch, getState) => {
    const { slug } = getState().caseData
    try {
      const newCommentThread = await Orchard.graft(
        `cases/${slug}/comment_threads`,
        { commentThread: {}}
      )
      dispatch(addCommentThread(newCommentThread))
      return newCommentThread.id
    } catch (e) {
      ignoreClientError(e)
    }
  }
}

export function addCommentThread (data) {
  return { type: 'ADD_COMMENT_THREAD', data }
}

export function deleteCommentThread (threadId) {
  return async (dispatch, getState) => {
    const { cardId } = getState().commentThreadsById[threadId]
    try {
      await Orchard.prune(`comment_threads/${threadId}`)
      dispatch(removeCommentThread(threadId, cardId))
    } catch (e) {
      // e.g. 403 (not a moderator) or 423 (thread became non-empty / locked).
      ignoreClientError(e)
    }
  }
}

function removeCommentThread (
  threadId,
  cardId
) {
  return { type: 'REMOVE_COMMENT_THREAD', threadId, cardId }
}

export function hoverCommentThread (id) {
  return { type: 'HOVER_COMMENT_THREAD', id }
}
